// utils/CustomUploadAdapter.ts
import { API_BASE_URL } from '@/config/api.config';
export default class CustomUploadAdapter {
    private loader: any;
     uploadUrl: string;

    constructor(loader: any) {
        this.loader = loader;
        this.uploadUrl = `${API_BASE_URL}/upload-image/`; // hardcoded here
            }

    upload() {
        return this.loader.file.then((file: File) => {
            return new Promise((resolve, reject) => {
                const data = new FormData();
                data.append('file', file);

                const xhr = new XMLHttpRequest();
                xhr.open('POST', this.uploadUrl, true);
                xhr.responseType = 'json';

                xhr.onload = () => {
                    if (xhr.status === 200 && xhr.response?.url) {
                        resolve({ default: xhr.response.url });
                    } else {
                        reject(`Upload failed: ${xhr.statusText}`);
                    }
                };

                xhr.onerror = () => {
                    reject('Upload failed due to network error.');
                };

                xhr.send(data);
            });
        });
    }

    abort() {
        // Optional: handle abort logic if needed
    }
}
